import React, { useState } from "react";
import HallowButton from "../../components/customComponents/HallowButton";
import { useDispatch, useSelector } from "react-redux";
import TaxDetailModal from "../../components/Modal/TaxDetailModal";
import { setTaxDetailsModal } from "../../reducer/modalReducer";
import { RootState } from "../../app/store";

export default function PATTaxDetailsSection() {
  const dispatch = useDispatch();
  const { VAT, TIN } = useSelector((state: RootState) => state.registration);

  const handleEditButtonClick = () => {
    dispatch(setTaxDetailsModal(true));
  };

  return (
    <div className={Classname.container}>
      <TaxDetailModal />
      <div className={Classname.flexBetween}>
        <div className="font-semibold mb-3">Tax details</div>

        <HallowButton label="Edit" onClick={handleEditButtonClick} />
      </div>

      <div className={Classname.listContainer}>
        <div className={Classname.title}>VAT number</div>
        {VAT ? (
          <div>{VAT}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
      <div className={Classname.listContainer}>
        <div className={Classname.title}>Tax Identification number (TIN)</div>
        {TIN ? (
          <div>{TIN}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
    </div>
  );
}

const Classname = {
  container: "bg-white pb-10 rounded-md p-2 h-fit gap-3 flex flex-col lg:px-10",
  flexBetween: "flex justify-between mt-5",
  title: "font-bold w-56",
  listContainer: "flex lg:gap-32 flex-col lg:flex-row",
  unspecified: "text-red-500 ",
};
